module.exports = __webpack_public_path__ + "img/img14.ab2bd15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/08/img14.jpg
// module id = 310
// module chunks = 0